export default "__VITE_ASSET__Blw2UyFW__"